import { Component, OnInit } from '@angular/core';
import * as decode from 'jwt-decode';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'app/services/general.service';
import { Router } from '@angular/router';
import { TranslateService } from 'ng2-translate';
import { ModalComunicadoComponent } from 'app/modal-comunicado/modal-comunicado.component';
import { saveAs } from 'file-saver/FileSaver';
import { ModalComunicadosShowComponent } from '../comunicados-show/comunicados-show';

@Component({
  selector: 'app-comunicados',
  templateUrl: './comunicados.component.html',
  styleUrls: ['./comunicados.component.scss']
})
export class ComunicadosComponent implements OnInit {

  userToken;
  userId;
  isExternal;
  perfilId;
  providerActive;
  data: any = {};

  Notices=[];
  constructor(private toastr: ToastrService,
    public dialog: MatDialog,
    private gralService: GeneralService,
    private router: Router,
    private translate: TranslateService,
    private adapter: DateAdapter<any>) {

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');

    const tokenPayload = decode(d[1]);

    this.userId = tokenPayload.Id;
    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;

    gralService.changeTextHead('NOTICE');

    this.listNotice();
  }

  ngOnInit() {
    this.data.FechaFin = new Date();
  }

  add(){
    this.dialog.open(ModalComunicadoComponent, {
      // disableClose:true,
      hasBackdrop: true,
      minWidth: '80%',
      // position: {
      //   top: '6%'
      // },
      data: { update: false }
    }).afterClosed().subscribe(res=>{
      console.log(res);
      if(res.update){
        this.listNotice();
      }
    });
  }

  show( id:string ){
    this.dialog.open(ModalComunicadosShowComponent, {
      // disableClose:true,
      hasBackdrop: true,
      minWidth: '80%',
      // position: {
      //   top: '6%'
      // },
      data: { id: id }
    });

    /*.afterClosed().subscribe(res=>{

    });*/
  }


  listNotice(){
    this.gralService.getNotice('123').then((res:any) => {
      if(res.TotalEntidades > 0){
        this.Notices = res.Entidades;
      }
    })
  }

  detailDoc(id){
    this.gralService.getSingleNote(id, 'token').then((res:any) => {

      const sampleBytes = this.base64ToArrayBuffer(res.Entidad.ComunicadoPDFBase64);
      const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });

      let mimeType = '.pdf';

      let fileName= Date.now();
      let tempName = fileName+mimeType;

      saveAs(blob, tempName);
    });
  }

  base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  delete(id){
    this.gralService.deleteNotice(id, '123').then((res:any)=>{
      if(res.EsValido){
        this.toastr.success('Comunicado eliminado correctamente', 'Sin Datos');
        this.listNotice();
        return false;
      }else{
        this.toastr.error('No se pudo eliminar en este momento intentalo más tarde', 'Error');
        return false;
      }
    });
  }

  edit(noticeId){
    this.dialog.open(ModalComunicadoComponent, {
      // disableClose:true,
      hasBackdrop: true,
      minWidth: '80%',

      data: { update: true, noticeId: noticeId }
    }).afterClosed().subscribe(res=>{
      console.log(res);
      if(res && res.update){
        this.listNotice();
      }
    });
  }
}
